export default class CurrentAccount {
    constructor($rootScope, $timeout, Account, Setting) {
        this.accountRepo = Account;
        this.settingsRepo = Setting;
        this._rootScope = $rootScope;
        this._timeout = $timeout;

        this._rootScope.$on('event:auth.loginSucceeded', () => {
            this._timeout(() => {
                this.init();
            }, 500);
        });
    }

    init() {

        this.data = {
            hasAvailableAccounts: false,
            account: { account: null },
            availableAccounts: [],
            subscriberCount: 0,
            accountName: '',
            sendCount: 0
        };

        this.settingsRepo.getAccountDetails().then((details) => {
            this.data.accountName = details.accountName;
            this.hasSharedTags = details.hasSharedTags;
            this.updateRemainingSubscriberCount();

            this.accountRepo.getAvailableAccounts().then((availableAccounts) => {
                this.data.availableAccounts = availableAccounts.data.availableAccounts;
                this.data.account = availableAccounts.data;
                this.data.hasAvailableAccounts = this.data.availableAccounts.length > 1;

                if (this.data.hasAvailableAccounts) {
                    angular.forEach(this.data.availableAccounts, (account) => {
                        if (account.name == this.data.accountName) {
                            account.active = true;
                        }
                    });
                }
                this._rootScope.$broadcast('currentAccount:initialized');
            });
        });
        
        this.getRemainingSendCount();
    }
    
    getData() {
        return this.data;
    }

    hasAvailableAccounts() {
        return this.data.hasAvailableAccounts;
    }
    
    availableAccounts() {
        return this.data.availableAccounts;
    }

    name() {
        return this.data.accountName;
    }

    account() {
        return this.data.account;
    }

    sendCount() {
        return this.data.sendCount;
    }

    subscriberCount() {
        return this.data.subscriberCount;
    }

    getRemainingSendCount() {
        this.accountRepo.getRemainingSendCount().then((sendCount) => {
            this.data.sendCount = sendCount;
        });
    }

    updateRemainingSubscriberCount() {
        this.accountRepo.getRemainingSubscriberCount().then((subscriberCount) => {
            this.data.subscriberCount = subscriberCount;
        });
    }
}
